module.exports = __webpack_public_path__ + "static/media/Nederland.b3b7661f.svg";